import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorId}/custom-terms-dynamic-variables/bulk';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const bulkFindOrCreateTypedCustomTermsDynamicVariables = async ({
  connectTemplateId,
  creatorId,
  items,
}: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const data = await noodleApiClient.post(path, {
    connectTemplateId,
    items,
  });
  return data.data;
};

export default bulkFindOrCreateTypedCustomTermsDynamicVariables;
